import React from 'react';
import Img01 from '../images/Office/contact-img.jpg';
import ContactImg1400 from '../images/Office/contact-img1400.jpg';
import { ImageModule } from "./common/Image_Module";
import {AltSiteName, TeamBaseURL} from './utils'
import { Link } from "gatsby"

const GetStaff = (props) => {
    var team = props.member
    
    if(team) {
    return (          
      <React.Fragment>     
        <div className={props.class?props.class:"contact-details area-guide"}>          
          <div className="contact-wrapper">
            <div className="contact-img">
              {team?.Staff_Image &&
                <ImageModule ImageSrc={team.Staff_Image} ggfx_results={team.ggfx_results} altText={team.Staff_Image.alternativeText ? team.Staff_Image.alternativeText : team.Name+' - '+team.Designation} strapi_id={team.id} imagename={"teams.Staff_Image.sidebartile"} />
              }
             {/* <img src={team?.Staff_Image && team?.Staff_Image?.url} alt={team.Staff_Image.alternativeText?team.Staff_Image.alternativeText:team.Name+' - '+team.Designation+AltSiteName}></img> */}
            </div>
            <div className={props.contactclass?props.contactclass:"contact-info "}>
              <h3>{team.Name}</h3>
              <span className="profile">{team.Designation}</span>
              <span>
                <Link to={`/contact?tid=${team.id}`} className="dark-text">Send email</Link> or <insidespan className="call-right-span">call
                <a href={`tel:${team.Phone_Number}`} className="tel">{team.Phone_Number}</a></insidespan>
              </span>
            </div>
          </div>   
          {/* {!props.hidecta &&
            <Link to={`${TeamBaseURL}/${team.URL}`} className="btn btn-primary">Contact Us</Link>    
          } */}
          {!props.hidecta &&
          <Link to={`/branches/`} className="btn btn-primary">Contact Us</Link> 
          }
          </div>     
      </React.Fragment>
      )
    } else {
      return (
        <empty></empty>
      )
    }
  };
  export default GetStaff;